/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LoaderThreeDots from 'DesignSystem/LoaderThreeDots/index'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Loading({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/CreditCardCapture/Loading"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<div
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-2mx3jB': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pb-2-2mx3jB': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<LoaderThreeDots
  viewPath={`${viewPath}/LoaderThreeDots`}
/>
</div>
{children}
</React.Fragment>)
}